import http from '@/api/common'

export default {
  authUser (credentials, callback, error) {
    return http.post('auth/gettoken', credentials)
  },
  requestPasswordReset (email) {
    return http.post('users/requestpasswordreset', email)
  },
  setNewPassword (user) {
    return http.post('users/setnewpassword', user)
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/auth.js